import { createStore, compose, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';

// import the roots
import rootReducer from './redux-sagas/reducers/index';
import rootSaga from './redux-sagas/sagas/root';

const sagaMiddleware = createSagaMiddleware()

const defaultState = {
    affiliates: null,
    affiliate: null,
    alumnis: null,
    alumni: null,
    ageGroups: null,
    entries: null,
    groupings: null,
    hotels: null,
    hotel: null,    
    medals: null,
    medal: null,
    past: null,
    seasonTypes: null,
    sponsor: null,
    sponsors: null,
    tournaments: null,
    tournament: null,
    tournamentSeasons: null,
    upcoming: null,
    qas: null,
    qa: null,
    qasCategories: [
        { name: 'About 3v3', value: 1 },
        { name: 'Tournaments', value: 2 },
        { name: 'Registration', value: 3 }
    ],
    seasonHotels: null,
    contactEmailList: null,
    /*contactCategories: [
        { name: 'Sports Logic / SL Team App Registration Help', value: 1 },
        { name: 'Schedule / Division Questions', value: 2 },
        { name: 'General Tournament Questions', value: 3 },
        { name: 'Nationals Questions', value: 4 },
        { name: 'General Comments', value: 5 },
        { name: 'Rankings', value: 6 },
        { name: 'Other / Not Listed', value: 7 },
    ]*/
};

// TODO: understand this ?
const enhancers = compose(
    applyMiddleware(sagaMiddleware),
    window.devToolsExtension ? window.devToolsExtension() : f => f
);
const store = createStore(
    rootReducer,
    defaultState,
    enhancers
);
//

sagaMiddleware.run(rootSaga)

export default store;



// WEBPACK FOOTER //
// ./src/store.js